import { render, staticRenderFns } from "./ClustersFirebase.vue?vue&type=template&id=1c475768&"
import script from "./ClustersFirebase.vue?vue&type=script&lang=js&"
export * from "./ClustersFirebase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports